import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import React, { FC, useCallback, useState } from 'react'
import styled from 'styled-components'

import type { UseProducts } from '../../../lib/products'
import { GetProductsQueryResults } from '../../../lib/products'

export interface LoadPreviousProductsProps {
  className?: string
  loading: boolean
  pagination: UseProducts['pagination']
  products?: GetProductsQueryResults | null
}

const LoadPreviousProducts: FC<LoadPreviousProductsProps> = ({
  className,
  loading,
  pagination,
  products,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const { data, actions } = pagination
  const { firstPage } = data
  const { fetchPrevPage } = actions

  const showLoadPreviousButton = firstPage > 1 && !!products?.meta?.pagination?.totalPages

  const fetchPrevProducts = useCallback(async () => {
    setIsLoading(true)
    try {
      await fetchPrevPage()
    } finally {
      setIsLoading(false)
    }
  }, [fetchPrevPage, setIsLoading])

  if (!showLoadPreviousButton) {
    return null
  }

  return (
    <div className={className}>
      {isLoading ? (
        <div className="loading-products">LOADING PRODUCTS...</div>
      ) : (
        <PrimaryButton
          text="Load previous products"
          onClick={() => fetchPrevProducts()}
          disabled={loading}
        />
      )}
    </div>
  )
}

LoadPreviousProducts.defaultProps = {
  className: '',
}

const StyledLoadMoreProducts = styled(LoadPreviousProducts)({
  marginBottom: '20px',
  textAlign: 'center',
  '.loading-products': {
    padding: '15px 0',
  },
})

export default StyledLoadMoreProducts
